import { z } from "zod"

export const signUpSchema = z
  .object({
    email: z
      .string()
      .min(1, { message: "Email is required" })
      .email({
        message: "Must be a valid email"
      }),
    password: z
      .string()
      .min(1, {
        message: "Password is required"
      })
      .min(8, {
        message: "Password must be at least 8 characters"
      }),
    confirmPassword: z.string().min(1, {
      message: "Confirm Password is required"
    })
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: "Passwords must match",
    path: ["confirmPassword"]
  })

export const signInSchema = z.object({
  email: z
    .string()
    .min(1, { message: "Email is required" })
    .email({
      message: "Must be a valid email"
    }),
  password: z.string().min(1, {
    message: "Password is required"
  })
})

export const userSchema = z.object({
  id: z.string().min(1),
  email: z.string().max(255).min(1)
})

export const updateUserSchema = z
  .object({
    settings: z.object({
      randomHighlightNotification: z.object({
        time: z.string().max(20),
        enabled: z.boolean()
      }),
      amazonDomain: z.string().max(20)
    })
  })
  .strict()
